(function () {
  function getYouTubeId(url) {
    if (!url) return null;
    var regex = /(?:youtube(?:-nocookie)?\.com\/(?:.*v=|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,12})/;
    var match = url.match(regex);
    return match ? match[1] : null;
  }

  function buildOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'video-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = '\n      <div class="video-modal-content" tabindex="-1">\n        <button class="video-modal-close" aria-label="Close video">\n          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\n        </button>\n        <div class="video-modal-wrapper"></div>\n      </div>';
    overlay.addEventListener('click', function (evt) {
      if (evt.target === overlay) closeOverlay();
    });
    return overlay;
  }

  var overlay = null;
  var activeTrigger = null;

  function openOverlay(youtubeUrl, triggerEl) {
    var id = getYouTubeId(youtubeUrl);
    if (!id) return;
    if (!overlay) {
      overlay = buildOverlay();
      document.body.appendChild(overlay);
    }
    var wrapper = overlay.querySelector('.video-modal-wrapper');
    wrapper.innerHTML = '';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    wrapper.appendChild(iframe);

    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    activeTrigger = triggerEl;

    // focus management
    var content = overlay.querySelector('.video-modal-content');
    if (content) content.focus();

    // close button
    var closeBtn = overlay.querySelector('.video-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeOverlay);
    }

    document.addEventListener('keydown', onKeyDown);
  }

  function closeOverlay() {
    if (!overlay) return;
    var wrapper = overlay.querySelector('.video-modal-wrapper');
    if (wrapper) wrapper.innerHTML = '';
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeyDown);
    if (activeTrigger) activeTrigger.focus({ preventScroll: true });
    activeTrigger = null;
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeOverlay();
    }
  }

  // delegate clicks (play button or item click)
  document.addEventListener('click', function (e) {
    var play = e.target.closest('.media-grid--play');
    var item = e.target.closest('.media-grid--item[data-youtube-url]');

    if (play) {
      var url = play.dataset.youtubeUrl || play.getAttribute('data-youtube-url');
      if (url) {
        e.preventDefault();
        openOverlay(url, play);
      }
      return;
    }

    if (item && !e.target.closest('a, button, input')) {
      var url = item.dataset.youtubeUrl || item.getAttribute('data-youtube-url');
      if (url) {
        e.preventDefault();
        openOverlay(url, item);
      }
    }
  });
})();
